<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Layout from "@/router/layouts/main";
import Multiselect from "vue-multiselect";

import {
  GET_VEHICLE,
  GET_VEHICLE_ID,
  VEHICLE_MUTATION_UPDATE,
} from "@/services/api/master/fleet";

export default {
  page: {
    title: "Master",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  apollo: {
    vehicles: {
      query: GET_VEHICLE,
      variables() {
        return {
          filter: {
            status: [],
          },
        };
      },
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.vehicles.vehicles.length;
          this.filteredItems = data.vehicles.vehicles;
        }
      },
    },
  },
  data() {
    return {
      phaseOneShow: false,
      filterApi: {
        status: [],
      },
      filterSelected: [],
      selectAll: false,
      updateFleet: [],
      typeFleet: null,
      modelFleet: null,
      typeBox: null,
      typeTermo: null,
      garasi: null,
      pengemudi: null,
      vendorPelacak: null,
      fav: null,
      vehicles: {
        vehicles: [],
      },
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      show_model: [],
      show: [
        { key: "vehicleType.type", label: this.$t('master.list.fleet.fleetType') },
        { key: "driver1.fullname", label: this.$t('master.list.fleet.1stDriver') },
        { key: "vehicleType.model", label: this.$t('master.list.fleet.fleetBrandType') },
        { key: "thermoType", label: this.$t('master.list.fleet.thermoType') },
        { key: "status", label: "Status" },
        { key: "odometer", label: this.$t('master.list.fleet.lastOdometer') },
        { key: "ownership", label: this.$t('master.list.fleet.ownership')}
      ],
      fields: [
        {
          key: "check",
          thClass: "mc-table--30",
          sortable: false,
        },
        {
          key: "licensePlate",
          label: this.$t('master.list.fleet.licensePlate'),
          sortable: true,
          type: "data",
        },
        {
          key: "vehicleType.type",
          label: this.$t('master.list.fleet.fleetType'),
          sortable: true,
        },
        {
          key: "driver1.fullname",
          label: this.$t('master.list.fleet.1stDriver'),
          sortable: true,
        },
        {
          key: "vehicleType.model",
          label: this.$t('master.list.fleet.fleetBrandType'),
          formatter: (value, _, item) => {
            return `${item.vehicleType.manufacturer} - ${value}`;
          },
          sortable: true,
        },
        {
          key: "thermoType",
          label: this.$t('master.list.fleet.thermoType'),
          sortable: true,
        },
        {
          key: "status",
          label: "Status",
          sortable: true,
        },
        {
          key: "odometer",
          label: this.$t('master.list.fleet.lastOdometer'),
          sortable: true,
        },
        {
          key:"ownership",
          label: "Ownership",
          sortable: true,
        }
      ],
      isAddFavorit: false,
      addFavorit: null,
      modalUpdateStatus: false,
      status: "I",
      filteredItems: [],
      filterStatus: {
        all: true,
        active: false,
        service: false,
      },
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    title() {
      // return this.$t("setting.list.userSetting.pengaturanPengguna");
      return this.$t("master.kendaraan");
    },

    rows() {
      return this.vehicles.vehicles.length;
    },

    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key);

        return this.fields.filter(function (item) {
          return (
            item.key == "check" ||
            item.key == "licensePlate" ||
            result.includes(item.key)
          );
        });
      } else {
        return this.fields;
      }
    },
  },
  mounted() {
    this.$apollo.queries.vehicles.refetch();
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems;
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    toggleAll(event) {
      var checked = event.target.checked;
      this.filterSelected = [];
      if (checked) {
        this.filterSelected = this.vehicles.vehicles.map((item) => item.id);
      } else {
        this.filterSelected = [];
      }
    },

    checkTable(event) {
      if (event.target.checked) {
        this.filterSelected.push(parseInt(event.target.value));
        if (this.filterSelected.length == this.vehicles.vehicles.length) {
          this.selectAll = true;
        }
      } else {
        this.selectAll = false;
        var index = this.filterSelected.indexOf(parseInt(event.target.value));
        if (index !== -1) {
          this.filterSelected.splice(index, 1);
        }
      }
    },

    showAllStatus() {
      let obj = { ...this.filterStatus };
      Object.keys(obj).forEach(function (key) {
        obj[key] = key === "all";
      });
      this.filterStatus = obj;
    },

    updateFilterStatus(param) {
      this.filterStatus[param] = !this.filterStatus[param];
      if (param !== "all") {
        this.filterStatus.all = false;
      }
      this.filterByStatus();
    },

    async filterByStatus() {
      var data = [];
      var status = [];

      if (this.filterStatus.active) {
        status.push("I");
      }

      if (this.filterStatus.service) {
        status.push("R");
      }
      if (status.length > 0) {
        await this.$apollo.queries.vehicles.refetch({
          filter: {
            status: status,
          },
        });
        data.push(...this.vehicles.vehicles);
      }

      // Check if all selected
      let obj = { ...this.filterStatus };
      let objArr = [];
      Object.keys(obj).forEach(function (key) {
        if (obj[key]) {
          objArr.push(key);
        }
      });
      let exceptAll = Object.keys(obj).filter((key) => key != "all").length;
      if (
        objArr.length === exceptAll ||
        objArr.length === 0 ||
        objArr[0] === "all"
      ) {
        this.showAllStatus();
        data = [];
        await this.$apollo.queries.vehicles.refetch({
          filter: {
            status: ["I", "R", "A"],
          },
        });
        data.push(...this.vehicles.vehicles);
      }

      this.vehicles.vehicles = data;
      this.filteredItems = data;
    },

    clearTable() {
      this.filterSelected = [];
      this.selectAll = false;
      this.resetModal();
    },

    showUpdateStatus(status) {
      this.status = status;
      for (let i = 0; i < this.filterSelected.length; i++) {
        this.$apollo
          .query({
            query: GET_VEHICLE_ID,
            variables: {
              filter: {
                id: parseInt(this.filterSelected[i]),
              },
            },
            fetchPolicy: 'no-cache',
          })
          .then((res) => {
            var isSuccessful = res.data.vehicle.isSuccessful;
            if (isSuccessful) {
              this.updateFleet.push(res.data.vehicle.vehicle);
            }
          });
      }
      this.$bvModal.show("modal-update-status");
    },

    updateByStatus(bvModalEvent) {
      bvModalEvent.preventDefault();
      let promises = [];

      for (let i = 0; i < this.filterSelected.length; i++) {
        promises.push(
          this.$apollo.mutate({
            mutation: VEHICLE_MUTATION_UPDATE,
            variables: {
              input: {
                oldData: {
                  licensePlate: this.updateFleet[i].licensePlate,
                  status: this.updateFleet[i].status,
                },
                newData: {
                  licensePlate: this.updateFleet[i].licensePlate,
                  status: this.status,
                },
                id: this.filterSelected[i],
              },
            },
          })
        );
      }

      Promise.all(promises).then(() => {
        this.$apollo.queries.vehicles.refetch();
        this.clearTable();
        this.$bvModal.hide("modal-update-status");
        this.$toast.success(`Data berhasil diubah`);
      });
    },

    resetModal() {
      this.status = null;
      this.updateFleet = [];
    },
  },

};
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">{{ $t('master.textKendaraan') }}</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-dropdown
            right
            variant="primary"
            menu-class="dropdown-menu-end"
            v-if="phaseOneShow"
          >
            <template v-slot:button-content>
              Unduh <i class="mdi mdi-chevron-down ps-2"></i>
            </template>
            <b-dropdown-item
              ><i class="bx bx-book-content pe-1"></i> Unduh Tabel
              Excel</b-dropdown-item
            >
            <b-dropdown-item
              ><i class="bx bx-book-content pe-1"></i> Unduh Tabel
              PDF</b-dropdown-item
            >
          </b-dropdown>
          <b-button
            @click="$router.push({ name: 'Master Home Page' })"
            variant="outline-primary"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t("global.back") }}
          </b-button>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <div class="mc-table-filter__status pb-4">
            <b-button
              :variant="filterStatus.all ? 'secondary' : 'light'"
              size="sm"
              class="me-2"
              @click="updateFilterStatus('all')"
            >
            {{ $t('global.filter.all') }}
            </b-button>
            <b-button
              :variant="filterStatus.active ? 'secondary' : 'light'"
              size="sm"
              class="me-2"
              @click="updateFilterStatus('active')"
            >
              {{ $t('master.form.fleet.status.active') }}
            </b-button>
            <b-button
              :variant="filterStatus.service ? 'secondary' : 'light'"
              size="sm"
              class="me-2"
              @click="updateFilterStatus('service')"
            >
              {{ $t('master.form.fleet.status.repair') }}
            </b-button>
          </div>
        </div>

        <div class="col-md-6 text-end">
          <div class="mc-table-filter">
            <a
              v-b-modal.modal-filter
              class="popup-form btn btn-outline-primary me-2"
              href="javascript: void(0);"
              v-if="phaseOneShow"
            >
              <i class="mc-fa icon-outline_filter"></i> Filter
            </a>
            <b-dropdown
              variant="outline-primary"
              class="ms-2"
              v-if="filterSelected.length"
            >
              <template v-slot:button-content>
                {{ $t('master.form.fleet.status.update') }}
                <i class="mdi mdi-chevron-down"></i>
              </template>
              <b-dropdown-item @click="showUpdateStatus('I')"
                >{{ $t('master.form.fleet.status.active') }}</b-dropdown-item
              >
              <b-dropdown-item @click="showUpdateStatus('R')"
                >{{ $t('master.form.fleet.status.repair') }}</b-dropdown-item
              >
              <b-dropdown-item @click="showUpdateStatus('A')"
                >{{ $t('master.form.fleet.status.archive') }}</b-dropdown-item
              >
              <b-modal
                class="mc-modal"
                id="modal-update-status"
                title="Ubah Status"
                body-class="p-3"
                size="md"
                centered
                @hidden="resetModal"
              >
                <div class="card-body mc-modal__filter p-2">
                  <p>
                    Apakah anda yakin mengubah status data berikut menjadi
                    <b v-if="status === 'I'">Aktif</b>
                    <b v-if="status === 'R'">Perbaikan</b>
                    <b v-if="status === 'A'">Arsip</b> ?
                  </p>
                  <b-list-group>
                    <b-list-group-item
                      v-for="vehicle in updateFleet"
                      :key="vehicle.id"
                    >{{ vehicle.licensePlate }}
                    </b-list-group-item>
                  </b-list-group>
                </div>
                <template #modal-footer="{ cancel }">
                  <b-row class="mc-modal__filter-footer mx-0">
                    <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
                      <b-button variant="outline-primary" @click="cancel()" class="me-2">
                        Tidak
                      </b-button>
                      <b-button @click="updateByStatus" variant="primary"> Ya </b-button>
                    </b-col>
                  </b-row>
                </template>
              </b-modal>

              <!-- <b-dropdown-item @click="modalUpdateStatus = true">Arsip</b-dropdown-item> -->
            </b-dropdown>
            <b-modal
              class="mc-modal"
              id="modal-filter"
              title="Filter"
              size="lg"
              centered
              scrollable
            >
              <div class="card-body mc-modal__filter">
                <form>
                  <div class="mc-modal__filter-item">
                    <b-form-group
                      label="Status Kendaraan"
                      v-slot="{ ariaDescribedby }"
                    >
                      <b-form-checkbox-group
                        id="checkbox-group-1"
                        v-model="selected"
                        :options="[
                          'Semua',
                          'Aktif',
                          'Service',
                          // 'Arsip',
                        ]"
                        :aria-describedby="ariaDescribedby"
                        name="flavour-1"
                      ></b-form-checkbox-group>
                    </b-form-group>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Manufaktur</label>
                    <multiselect
                      v-model="modelFleet"
                      :options="[
                        'Mercedes',
                        'Mitsubishi',
                        'Suzuki',
                        'Hino',
                        'Mazda',
                      ]"
                      placeholder="Model Kendaraan"
                    ></multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label class="mt-3">Jenis Kendaraan</label>
                    <multiselect
                      v-model="typeFleet"
                      :options="['Super Wing', 'Akas', 'Box', 'Pickup']"
                      :multiple="true"
                      placeholder="Jenis Kendaraan"
                    ></multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Jenis Box</label>
                    <multiselect
                      v-model="typeBox"
                      :options="[
                        'Box Ice Cream',
                        'Box Truck Reefer Unit',
                        'Double Box',
                        'Dry',
                        'Dry Van',
                      ]"
                      placeholder="Jenis Box"
                    ></multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Jenis Termo</label>
                    <multiselect
                      v-model="typeTermo"
                      :options="[
                        'Denso',
                        'Denso 2',
                        'Hwasung Thermo',
                        'Mitsubishi',
                        'Thermo King',
                        'Thermo Queen',
                      ]"
                      placeholder="Jenis Termo"
                    ></multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Garasi</label>
                    <multiselect
                      v-model="garasi"
                      :options="[
                        'Bandung',
                        'Surabaya',
                        'Gresik',
                        'Semarang',
                        'Tangerang',
                        'Jogja',
                      ]"
                      :multiple="true"
                      placeholder="Garasi"
                    ></multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Pengemudi</label>
                    <multiselect
                      v-model="pengemudi"
                      :options="[
                        'Kang Tri',
                        'Kang Octa',
                        'Kang Hadi',
                        'Kang Perkasa',
                      ]"
                      placeholder="Pengemudi"
                    ></multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Vendor Pelacak</label>
                    <multiselect
                      v-model="vendorPelacak"
                      :options="[
                        'McEasy',
                        'EasyGo',
                        'Foxlogger',
                        'Concox',
                        'Tanpa Vendor',
                      ]"
                      placeholder="Vendor Pelacak"
                    ></multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <label>Tipe Perangkat</label>
                    <multiselect
                      v-model="vendorPelacak"
                      :options="[
                        'Concox X1',
                        'Concox X2',
                        'Concox X3',
                        'Concox X4',
                        'Concox X5',
                      ]"
                      placeholder="Tipe Perangkat"
                    ></multiselect>
                  </div>
                  <div class="mc-modal__filter-item">
                    <div class="form-check form-switch mb-3">
                      <input
                        type="checkbox"
                        id="switchArsip"
                        class="form-check-input"
                      /><label for="switchArsip" class="form-check-label"
                        >Tampilkan Status Arsip</label
                      >
                    </div>
                  </div>
                </form>
              </div>
              <template #modal-footer="{ cancel }">
                <b-row class="mc-modal__filter-footer">
                  <b-col sm="12" md="8" class="mc-modal__filter-footer-fav">
                    <b-row>
                      <b-col md="6">
                        <b-form-group
                          v-if="!isAddFavorit"
                          id="favorit-label-modal"
                          label="Favorit"
                          label-for="favorit-modal"
                        >
                          <multiselect
                            v-model="fav"
                            :options="[
                              'Semua Model',
                              'Semua Kendaraan',
                              'Semua Wing',
                            ]"
                            :show-labels="false"
                          ></multiselect>
                        </b-form-group>
                        <b-form-group
                          v-if="isAddFavorit"
                          id="favorit-add-label-modal"
                          label="Favorit"
                          label-for="favorit-modal-add"
                        >
                          <b-form-input
                            id="favorit-modal-add"
                            v-model="addFavorit"
                            placeholder="Nama Favorit"
                          ></b-form-input>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-button
                          v-if="!isAddFavorit"
                          variant="outline-primary"
                          @click="isAddFavorit = !isAddFavorit"
                        >
                          <i class="mdi mdi-file-plus-outline"></i> Buat Favorit
                          Baru
                        </b-button>
                        <b-button v-if="isAddFavorit" variant="outline-primary">
                          <i class="fas fa-save"></i> Simpan Sebagai Favorit
                        </b-button>
                        <i
                          v-if="isAddFavorit"
                          class="fas fa-trash text-danger text-lg mt-4 ms-3"
                          @click="isAddFavorit = !isAddFavorit"
                        ></i>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col sm="12" md="4" class="mc-modal__filter-footer-btn">
                    <b-button
                      variant="outline-primary"
                      @click="cancel()"
                      class="me-3"
                    >
                      Close
                    </b-button>
                    <b-button variant="primary"> Terapkan </b-button>
                  </b-col>
                </b-row>
              </template>
            </b-modal>

            <b-button
              variant="primary"
              class="ms-2"
              @click="$router.push({ name: 'Master Fleet Create' })"
            >
              <i class="mc-fa icon-outline_plus"></i>
              {{ $t("global.addField") }}
            </b-button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="filterSelected.length" class="mc-row-check">
              <span class="badge btn-success">{{ filterSelected.length }}</span>
              {{ $t('global.selectedRows') }}. <a class="color-primary" @click="clearTable">{{ $t('global.action.clearAll') }}</a>
            </h6>
          </div>

          <div
            class="
              col-sm-8 col-md-8
              d-flex
              flex-row-reverse
              mc-table-view-wrapper
            "
          >
            <div class="mc-table-view">
              <p class="mc-label">{{ $t('global.shown') }}</p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                :placeholder="$t('global.object.allColumn')"
                track-by="label"
                label="label"
              ></multiselect>
              <div
                id="tickets-table_filter"
                class="dataTables_filter text-md-end"
              >
                <label
                  class="d-inline-flex align-items-center mc-table-view__search"
                >
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
          </div>
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :items="vehicles.vehicles"
            :fields="visibleFields"
            class="datatables"
            responsive="lg"
            sort-by="licensePlate"
            empty-table
            :empty-text="$t('global.emptyTable')"
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            @filtered="onFiltered"
            :busy="$apollo.queries.vehicles.loading"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>

            <template #head(check)>
              <div class="form-check">
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  value="all"
                  v-model="selectAll"
                  @input="toggleAll"
                />
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <input
                  class="form-check-input me-1"
                  type="checkbox"
                  :value="data.item.id"
                  v-model="filterSelected"
                  @input="checkTable"
                />
              </div>
            </template>

            <template #cell(licensePlate)="data">
              <strong
                class="text-primary"
                @click="
                  $router.push({
                    name: 'Master Fleet Update',
                    params: { id: data.item.id },
                  })
                "
              >
                {{ data.item.licensePlate }}
              </strong>
            </template>

            <template #cell(status)="data">
              <span
                class="mc-status mc-status--green"
                v-if="data.item.status === 'I'"
              >
                Aktif
              </span>
              <span
                class="mc-status mc-status--blue"
                v-else-if="data.item.status === 'R'"
              >
                Perbaikan
              </span>
              <span
                class="mc-status mc-status--red"
                v-else-if="data.item.status === 'A'"
              >
                Arsip
              </span>
            </template>

            <template #cell(odometer)="data">
              {{ data.item.odometer }} Km
            </template>

            <template #cell(ownership)="data">
              <span
                v-if="data.item.ownership === 'O'"
              >
              Own Transport
              </span>
              <span
                v-else-if="data.item.ownership === 'V'"
              >
              Vendor Transport
              </span>
              <span
                v-else-if="data.item.ownership === 'C'"
              >
              On-Call Transport
              </span>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                Menampilkan
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                >
                </b-form-select>
                entri.
                <p>
                  Menampilkan&nbsp;<strong>{{
                    filteredItems.length > 0
                      ? (currentPage - 1) * perPage + 1
                      : 0
                  }}</strong
                  >&nbsp;sampai&nbsp;<strong>{{
                    Math.min(filteredItems.length, currentPage * perPage)
                  }}</strong
                  >&nbsp;dari&nbsp;<strong>{{ filteredItems.length }}</strong
                  >&nbsp;entri.
                </p>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows == null ? rows : totalRows"
                  :per-page="perPage"
                ></b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>